import { DayKey, DayMeals, MealKey, MealPlanSubstitutions, WeeklyMealPlan, MealPlanNutrition } from '../types/mealPlan';

export const PLAN_DAYS: DayKey[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const MEALS: MealKey[] = ['breakfast', 'morningSnack', 'lunch', 'afternoonSnack', 'dinner', 'eveningSnack'];
export interface EditableMealPlan {
  revision?: number;
  nome: string;
  objetivo: string;
  observacoes: string;
  targetCalories?: number;
  protein?: number;
  carbohydrates?: number;
  fats?: number;
  weeklyPlan: WeeklyMealPlan;
  foodNutrients?: MealPlanNutrition;
  hydration: string;
  trainingTime?: string;
  durationWeeks?: number;
  substitutions?: MealPlanSubstitutions;
  bmr?: number;
  tdee?: number;
}

export function normalizeMealPlan(raw: Record<string, any>): EditableMealPlan {
  const number = (value: unknown): number | undefined => value == null || value === '' || !Number.isFinite(Number(value)) ? undefined : Number(value);
  const weeklyPlan = Object.fromEntries(PLAN_DAYS.map(day => {
    const source = raw.weeklyPlan?.[day] ?? raw.meals ?? {};
    const meals = Object.fromEntries(MEALS.map(meal => [meal,
      Array.isArray(source[meal]) ? source[meal].filter((item: unknown) => typeof item === 'string') : [],
    ])) as DayMeals;
    return [day, meals];
  })) as WeeklyMealPlan;
  return {
    revision: number(raw.revision) ?? 0,
    nome: String(raw.name ?? raw.title ?? raw.nome ?? 'Plano Alimentar'),
    objetivo: String(raw.goal ?? raw.objective ?? raw.objetivo ?? ''),
    observacoes: String(raw.notes ?? raw.observacoes ?? ''),
    targetCalories: number(raw.targetCalories ?? raw.dailyCalories),
    protein: number(raw.macronutrients?.protein ?? raw.protein),
    carbohydrates: number(raw.macronutrients?.carbohydrates ?? raw.carbohydrates),
    fats: number(raw.macronutrients?.fats ?? raw.fats),
    weeklyPlan,
    foodNutrients: raw.foodNutrients ?? {},
    hydration: String(raw.hydration ?? '2L/dia'),
    trainingTime: typeof raw.trainingTime === 'string' ? raw.trainingTime : undefined,
    durationWeeks: number(raw.durationWeeks ?? raw.duration),
    substitutions: raw.substitutions ?? undefined,
    bmr: number(raw.bmr),
    tdee: number(raw.tdee),
  };
}
